import React from 'react';
import {Card} from 'antd';
import InputComponent from '../../../atoms/Inputs/Input';
import styles from './style.module.css';

interface FormProps {
    email: string;
    emailValid: boolean;
    required: boolean;
    onEmailChange: (value: string) => void;
    title?: string;
    sameEmail?: boolean;
}

const SetEmailForm: React.FC<FormProps> = ({email, emailValid, required, onEmailChange, title, sameEmail}) => {
    return (
        <Card title={<span style={{color: '#1677ff', fontWeight: 'bold', fontSize: '30px'}}>{title}</span>}>
            <form className={styles.setPasswordForm}>
                <div>
                    <InputComponent label={'Email'} value={email} placeholder={''} type={'email'} labelPosition={'up'}
                                    required={required} onChange={onEmailChange}/>
                    {!emailValid && <span style={{color: 'red'}}>Email is not valid</span>}
                    {!sameEmail && emailValid && <span style={{color: 'red'}}>Not the same email!</span>}
                </div>
            </form>
        </Card>
    );
};

export default SetEmailForm;